import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../common/components/Dialog";
import { StyledButton } from "../../../common/components/Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { StyledTextField } from "../../../common/components/TextField/styles";
import DateInput from "../../../common/components/Input";
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { addPaymentTransactionManualSchema } from "../schema/addPaymentTransactionManualSchema";
import { manualPaymentWithCustomAmount } from "../../../api/caseApi";
const AddPaymentTransactionManualDialog = ({
  openAddPaymentTransaction,
  handleCloseAddPaymentTransaction,
  getPaymentTransactions,
  caseDetails,
}) => {
  const [types, setTypes] = useState([]);

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(addPaymentTransactionManualSchema),
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    let defaultValues = {};
    defaultValues.caseId = caseDetails.id;
    reset({ ...defaultValues });
    let designCount = 0,
      setCount = 0;
    setTypes([]);
    caseDetails.caseProgressions.forEach((cp) => {
      if (cp.type === "F2F Consultation") {
        let type = { name: "F2F Consultation Payment", caseProgressId: cp.id };
        setTypes((prev) => [...prev, type]);
      } else if (cp.type === "Scanning") {
        let type = { name: "Scanning Payment", caseProgressId: cp.id };
        setTypes((prev) => [...prev, type]);
      } else if (cp.type === "Design") {
        if (designCount === 0) {
          let type = { name: "Design Payment", caseProgressId: cp.id };
          setTypes((prev) => [...prev, type]);
          designCount++;
        }
      }
      // else if (cp.type === "Set") {
      //   if (setCount === 0) {
      //     let type = { name: "Set Payment", caseProgressId: cp.id };
      //     setTypes((prev) => [...prev, type]);
      //     setCount++;
      //   }
      // }
    });
  }, [caseDetails]);

  const submitPayCaseProgress = async (values) => {
    setIsSubmitting(true);
    values.modeOfPayment = "";
    await manualPaymentWithCustomAmount(values);
    handleCloseAddPaymentTransaction();
    getPaymentTransactions();
    setIsSubmitting(false);
    reset();
  };
  return (
    <div>
      <StyledDialog
        open={openAddPaymentTransaction}
        onClose={handleCloseAddPaymentTransaction}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>Manual Payment With Custom Amount</DialogTitle>
        <form onSubmit={handleSubmit(submitPayCaseProgress)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={6.5}>
                <Controller
                  control={control}
                  name="caseProgressId"
                  render={({ field: { onChange }, fieldState: { error } }) => (
                    <Autocomplete
                      options={types}
                      onChange={(_, val) => {
                        onChange(val?.caseProgressId || "");
                      }}
                      getOptionLabel={(option) => option.name || option}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(error)}
                          label={"Payment Type"}
                          FormHelperTextProps={{ variant: "standard" }}
                          helperText={error && error.message}
                        />
                      )}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.caseProgressId}>
                            {option.name}
                          </li>
                        );
                      }}
                      sx={{ width: "100%", paddingBottom: "20px" }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6.5}>
                <StyledTextField
                  sx={{ width: "100%" }}
                  variant="outlined"
                  label="Transaction No."
                  InputProps={{ inputProps: { step: "any" } }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.transactionNo}
                  helperText={errors.transactionNo?.message}
                  {...register("transactionNo")}
                />
              </Grid>
              <Grid item xs={6.5}>
                <StyledTextField
                  sx={{ width: "100%" }}
                  variant="outlined"
                  label="Amount"
                  InputProps={{ inputProps: { step: "any" } }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={errors.amount}
                  helperText={errors.amount?.message}
                  {...register("amount")}
                />
              </Grid>
              <Grid item xs={6.5}>
                <DateInput label="Date" name="date" control={control} />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseAddPaymentTransaction}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddPaymentTransactionManualDialog;
